import { render, staticRenderFns } from "./Step4-Footer.vue?vue&type=template&id=eb01ee66&"
import script from "./Step4-Footer.vue?vue&type=script&lang=js&"
export * from "./Step4-Footer.vue?vue&type=script&lang=js&"
import style0 from "./Step4-Footer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports